import isUndefined from "lodash/isUndefined";

import { IE2EOpts, ITestable, TEST_ATTR, TEST_PROP, TEST_VALUE_ATTR, TEST_VALUE_PROP } from "./types";

type TMapCache = Map<string, { [x: string]: string }>;
const testMock = {};
function compose(cache: TMapCache, conf: { nameKey: string; valueKey: string }, props: ITestable, opts: IE2EOpts = {}) {
  const { testName, testValue } = props;
  const { id, sufix } = opts;

  if (!testName) {
    return testMock;
  }

  const cacheKey = [testName, testValue, id, sufix].filter(Boolean).join("-");

  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const idName = !isUndefined(id) ? `${testName}[${id}]` : testName;
  const nameSuffix = sufix ? `${idName}--${sufix}` : idName;

  const obj = {
    ...(!isUndefined(nameSuffix) ? { [conf.nameKey]: nameSuffix } : undefined),
    ...(!isUndefined(testValue) ? { [conf.valueKey]: testValue } : undefined),
  };

  // @ts-ignore
  cache.set(cacheKey, obj);
  return obj;
}

const propCache = new Map();
export function testProp(props: ITestable, opts?: IE2EOpts) {
  return compose(propCache, { nameKey: TEST_PROP, valueKey: TEST_VALUE_PROP }, props, opts);
}

const attrCache = new Map();
export function testAttr(props: ITestable, opts?: IE2EOpts) {
  return compose(attrCache, { nameKey: TEST_ATTR, valueKey: TEST_VALUE_ATTR }, props, opts);
}
